module.exports = __webpack_public_path__ + "static/media/flag_wales.d3bf953e.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/components/areaselect/flags/flag_wales.png
// module id = 1090
// module chunks = 23